import * as Constants from '../constants';

const initialState = {
  loading: true,
  loadingTime: true,
  slotDates: [],
  slotTimes: [],
  selectedSlot: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.GET_DIAGNOSTICS_SLOTS_DATE_START:
      return Object.assign({ ...state }, { slotDates: [] });
    case Constants.GET_DIAGNOSTICS_SLOTS_DATE_SUCCESS:
      return Object.assign({ ...state }, { slotDates: action.data.data.dates, slotTimes: action.data.data.first_date, loading: false, loadingTime: false });
    case Constants.GET_DIAGNOSTICS_SLOTS_DATE_FALIURE:
      return Object.assign({ ...state }, { loading: false, error: action.error, loadingTime: false });
    case Constants.GET_DIAGNOSTICS_SLOTS_TIME_START:
      return Object.assign({ ...state }, { slotTimes: [], loadingTime: true });
    case Constants.GET_DIAGNOSTICS_SLOTS_TIME_SUCCESS:
      return Object.assign({ ...state }, { loading: false, slotTimes: action.data.data.slots, loadingTime: false });
    case Constants.GET_DIAGNOSTICS_SLOTS_TIME_FAILURE:
      return Object.assign({ ...state }, { loading: false, error: action.error, loadingTime: false });
    case Constants.SET_SELECTED_SLOT:
      return Object.assign({ ...state }, { loading: false, selectedSlot: action.data, loadingTime: false });
    case Constants.RESET_TO_INITIAL_SLOT_STATE:
      return { ...initialState };
    default:
      return { ...state };
  }
}
